<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapState } from 'vuex'
  import CommentPreview from './CommentPreview'
  import FallbackAvatar from '@/components/ui/FallbackAvatar'
  import ConfirmationOverlay from '@/components/overlays/ConfirmationOverlay'

  export default {
    name: 'CommentButton',
    components: {
      CommentPreview,
      MentionInput: () => import('@/components/ui/MentionInput'),
      ConfirmationOverlay,
      FallbackAvatar,
    },
    props: {
      comments: Object,
      panelOpened: Boolean,
      hash: String,
      commentId: String,
      isLikesActive: Boolean,
    },
    data() {
      return {
        comment: '',
        expand: false,
        hover: false,
        isHidden: true,
        maximumRecordsToShow: 3,
        rows: 4,
        selectedOverlay: null,
        selectedCommentId: 0,
      }
    },
    computed: {
      ...mapState('auth', [
        'user',
        'settings',
      ]),
      getDeleteCommentObject() {
        const delete_comment_object = this.$t('cta.comments.overlays.delete')
        delete_comment_object['img'] = delete_comment_object['img'] || this.customerConfig.images.overlayBg
        return delete_comment_object
      },
      showMore() {
        return this.maximumRecordsToShow < (this.comments && this.comments.data && this.comments.data.comments && this.comments.data.comments.length)
      },
      commentButtonText() {
        return this.settings && this.settings.base_options && this.settings.base_options.theme_variant === 'variant' ? this.$t('cta.comments.commented') : ''
      },
    },
    watch: {
      panelOpened(val) {
        this.isHidden = !val
      },
      comment(val) {
        if (val) {
          this.rows = 4
        } else {
          this.rows = 2
        }
      },
    },
    mounted() {
      this.isHidden = this.hash && this.hash.indexOf('#comments-') === 0 &&
      (this.hash.split('-')[2] === this.commentId.split('-')[2]) ? false : true
    },
    methods: {
      onSubmit(args) {
        this.$emit('comment', this.comment)
        this.comment = ''
      },
      onToggleCommentIcon() {
        this.isHidden = !this.isHidden
        this.$emit('onTogglePanel', !this.isHidden ? 'comments' : null)
        this.rows = 2
        this.maximumRecordsToShow = 3
      },
      viewMore() {
        this.maximumRecordsToShow += 3
      },
      closeOverlay() {
        this.selectedOverlay = null
      },
      deleteCommentOptionActive(comment) {
        return (
            this.settings.stream_options &&
            this.settings.stream_options.delete_comments_option &&
            comment.permissions &&
            typeof comment.permissions.indexOf === 'function' &&
            comment.permissions.indexOf('delete_comment') > -1
        )
      },
      openOverlay(overlayType, id) {
        this.selectedCommentId = id
        this.selectedOverlay = overlayType
      },
      actionDeleteComment() {
        const postId = this.commentId.replace('comments-', '')
        this.$emit('onDeleteComment', this.selectedCommentId, postId)
        this.closeOverlay()
      },
    },
  }
</script>
